
/* injects from baggage-loader */

'use strict';

import _ from 'lodash';

import { shapes } from './logic-game.const';
import empty from '_images/red/shapes/empty.png';
import empty_locked from '_images/red/shapes/empty-locked.png';

export default class LogicGameController {
	constructor($log, $state, $timeout) {
		'ngInject';
		this.$log = $log;
		this.$state = $state;
		this.$timeout = $timeout;
		this.empty = {src: empty, alt: "Espaço vazio"};
		this.shapes = shapes;
		this.emptyLocked = {src: empty_locked, alt: "Espaço vazio bloqueado"};
		this.shapesSequency = [];
		this.shapesSequencyEmpty = [];
	}    

	$onInit(){
		this.title="<span class='level'>Sabedoria - Nível "+this.level+"</span><br/> Arraste para os espaços as figuras que completam a sequência";
		switch(this.level){
			case 1:
			this.numLines = 2;
			break;
			case 2:
			this.numLines = 4;
			break;
			default:
			case 3:
			this.numLines = -1;
		}
		this.shuffleShapes(this.shapes,this.numLines);
	}

	shuffleShapes(array, max){
		let i = 0;
		let shapesArray = [];
		if(max>0){
			for(i;i<max;i++){
				let aux = _.sampleSize(shapes,2);
				shapesArray.push(_.concat(aux,aux,_.dropRight(aux)));
			}
			this.shapesSequency = shapesArray;
			for(i = 0;i<max;i++){
				let rand = _.random(4);
				this.shapesSequencyEmpty[i] = rand;
			}
		} else {
			let aux = _.sampleSize(shapes,3);
			this.numStage = "third-stage";
			this.shapesSequency.push(this.fillArray(aux,20));
			this.emptyIndex = 4;
		}
	}

	isEmpty(sequency, index){
		if(this.numLines>0){
			if(index === this.shapesSequencyEmpty[sequency])
				return this.empty;
			else 
				return this.shapesSequency[sequency][index];
		} else {
			if(index>this.emptyIndex)
				return this.emptyLocked;
			else if(index===this.emptyIndex)
				return this.empty;
			else
				return this.shapesSequency[sequency][index];
		}
	}

	onDropShape(e, data, sequency, el){
		if(this.numLines>0){
			let index = this.shapesSequencyEmpty[sequency];
			if(e === index){
				if(data.data.alt === this.shapesSequency[sequency][index].alt){
					this.shapesSequencyEmpty[sequency] = -1;
					angular.element(el.target).addClass("zoomIn");					
					if(_.sum(this.shapesSequencyEmpty)<=(this.numLines*-1))
						this.endGame();
				}
				else {
					angular.element(el.target).removeClass("shake");
					this.$timeout(function() {angular.element(el.target).addClass("shake");},100);
				}
			} 
		} else {
			if(e === this.emptyIndex){
				if(data.data.alt === this.shapesSequency[0][this.emptyIndex].alt){
					this.emptyIndex++;
					angular.element(el.target).addClass("zoomIn");
					if(this.emptyIndex>=this.shapesSequency[0].length)
						this.endGame();
				}
				else {
					angular.element(el.target).removeClass("shake");
					this.$timeout(function() {angular.element(el.target).addClass("shake");},100);
				}
			}
		}
	}

	fillArray(arr, size){
		let arrayFilled = []
		for (let i = 0 ; i < size; i++) {
			arrayFilled.push(arr[i%arr.length]);
		}
		return arrayFilled;
	}
}


// WEBPACK FOOTER //
// ./src/app/components/ui/logic-game/logic-game.controller.js